import React from "react"
import { useDispatch } from "react-redux"
import profileHashMap from "../ApplicationEditor/profileHashMap"
import UserFieldEditor from "../UserFieldEditor/UserFieldEditor"
import Actions from "../../Redux/Actions"

/*
  This component's primary objective is to pass in the inputs required to map for UserFieldEditor.
  It seems small, but it allows us to share a lot of code between the Application Process and Profile and gives
  a place for adding functionality specific to either one.
*/

const ProfileInputs = () => {
  const dispatch = useDispatch()

  const handleSetInputData = (inputData) => {
    // For profile pages, store input data in application state so ProfileFooter can access it
    dispatch(Actions.setInputData(inputData))
  }

  return <UserFieldEditor inputs={profileHashMap} setInputData={handleSetInputData} />
}

export default ProfileInputs
